(function (angular) {
	angular.module('bizPartEngage').directive('bizCookieSettings', bizCookieSettingsDirective);

	bizCookieSettingsDirective.$inject = ["bizCore"];

	function bizCookieSettingsDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {

			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl;
				}
				else {
					return bizCoreProvider.getView('core.directives.cookiesettings', "FrontEnd/Core/Directives/Views/CookieSettings.html");
				}
			},
			bindToController: true,
			controller: bizCookieSettingsController,
			controllerAs: "vm"
		};

		bizCookieSettingsController.$inject = ["$rootScope", "bizCoreService"];

		function bizCookieSettingsController($rootScope, bizCoreService) {
			var vm = this;

			//vm.Cookies = [{
			//	Name: "Bizpart",
			//	Value: "",
			//	Group: "Functional",
			//	Mandatory: true
			//}, {
			//	Name: "Google",
			//	Value: "",
			//	Group: "Tracking",
			//	Mandatory: false
			//}
			//];

			vm.ToggleStatistics = ToggleStatistics;
			vm.ToggleMarketing = ToggleMarketing;

			function ToggleStatistics() {
				var accepted = !$rootScope.HasAcceptedCookieOfType('statistics');
				$rootScope.HasAcceptedStatisticsCookies = accepted;
				setLocalStorage("HasAcceptedStatisticsCookies", accepted);
				UpdateCompatibilityConsent();
				$rootScope.$broadcast('cookieConsentChanged', accepted);

				if ($rootScope.IsLoggedIn) {
					bizCoreService.UpdateUserSetting("HasAcceptedStatisticsCookies", accepted);
					bizCoreService.UpdateUserSetting("HasAcceptedCookies", $rootScope.HasAcceptedCookies);
				}
            }

			function ToggleMarketing() {
				var accepted = !$rootScope.HasAcceptedCookieOfType('marketing');
				$rootScope.HasAcceptedMarketingCookies = accepted;
				setLocalStorage("HasAcceptedMarketingCookies", accepted);
				UpdateCompatibilityConsent();
				$rootScope.$broadcast('cookieConsentChanged', accepted);

				if ($rootScope.IsLoggedIn) {
					bizCoreService.UpdateUserSetting("HasAcceptedMarketingCookies", accepted);
					bizCoreService.UpdateUserSetting("HasAcceptedCookies", $rootScope.HasAcceptedCookies);
				}
			}

			function UpdateCompatibilityConsent() {
				$rootScope.HasAcceptedCookies = $rootScope.HasAcceptedCookieOfType('statistics') && $rootScope.HasAcceptedCookieOfType('marketing');
				setLocalStorage("HasAcceptedCookies", $rootScope.HasAcceptedCookies);
			}

            function Init() {
            }

			vm.$onInit = function () {
				Init();
			}
		}

		return directive;
	}
})(window.angular);
